import jwt_decode from 'jwt-decode';
import { SET_LOGIN_USER_REQUEST,
         SET_LOGIN_USER_SUCCESS,
         SET_LOGIN_USER_ERROR } from './../../constants/auth/auth';

const LOGIN_INITIAL_STATE = {
    loading: false,
    error: null
}

export const loginReducer = (state=LOGIN_INITIAL_STATE, action) => {
    switch(action.type) {
        case SET_LOGIN_USER_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            }
        case SET_LOGIN_USER_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            }
        case SET_LOGIN_USER_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        default:
            return state;
    }
}
